import type { RoomType } from "@/types/schedule"
import room1 from "@/assets/rooms/room-1.jpg"
import room2 from "@/assets/rooms/room-2.jpg"
import room3 from "@/assets/rooms/room-3.jpg"
import room4 from "@/assets/rooms/room-4.jpg"
import room5 from "@/assets/rooms/room-5.jpg"
import room6 from "@/assets/rooms/room-6.jpg"

/** Phòng mock để dựng giao diện danh sách phòng nghỉ */
export interface MockRoom {
    id: string
    name: string
    type: RoomType
    image: string
    /** Giá theo 1 slot (VND) */
    pricePerSlot: number
    /** Điểm đánh giá trung bình (0–5) */
    rating: number
    /** Số lượt đánh giá */
    reviewCount: number
    /** Sức chứa (khách) */
    guests: number
    /** Diện tích (m²) */
    areaM2: number
    /** Mô tả giường */
    bed: string
    /** Số khung giờ đặt được */
    slotCount: number
    /** Danh sách tiện nghi */
    amenities: string[]
}

export const MOCK_ROOMS: MockRoom[] = [
    {
        id: "cherry",
        name: "BB's Cherry",
        type: "standard",
        image: room1,
        pricePerSlot: 239000,
        rating: 4.8,
        reviewCount: 9,
        guests: 2,
        areaM2: 18,
        bed: "1 giường đôi",
        slotCount: 4,
        amenities: ["WiFi miễn phí", "Máy chiếu", "Điều hòa", "Vòi sen nóng lạnh", "Tủ lạnh trong phòng"],
    },
    {
        id: "pinterest",
        name: "BB's Pinterest",
        type: "standard",
        image: room4,
        pricePerSlot: 239000,
        rating: 4.7,
        reviewCount: 10,
        guests: 2,
        areaM2: 22,
        bed: "1 giường đôi",
        slotCount: 4,
        amenities: ["WiFi miễn phí", "Smart TV 60inches", "Điều hòa", "Vòi sen nóng lạnh", "Trà & Cà phê"],
    },
    {
        id: "oasis",
        name: "BB's Oasis",
        type: "vip",
        image: room2,
        pricePerSlot: 319000,
        rating: 4.9,
        reviewCount: 6,
        guests: 2,
        areaM2: 25,
        bed: "1 giường đôi King size",
        slotCount: 4,
        amenities: ["WiFi tốc độ cao", "Máy chiếu", "Điều hòa", "Vòi sen nóng lạnh", "Bàn trang điểm"],
    },
    {
        id: "forest",
        name: "BB's Forest",
        type: "standard",
        image: room3,
        pricePerSlot: 249000,
        rating: 4.6,
        reviewCount: 12,
        guests: 2,
        areaM2: 20,
        bed: "1 giường đôi",
        slotCount: 4,
        amenities: ["WiFi miễn phí", "Máy chiếu", "Điều hòa", "Vòi sen nóng lạnh", "Tủ lạnh trong phòng"],
    },
    {
        id: "canvas",
        name: "BB's Canvas",
        type: "supervip",
        image: room5,
        pricePerSlot: 389000,
        rating: 5.0,
        reviewCount: 4,
        guests: 3,
        areaM2: 32,
        bed: "1 giường tròn + bồn tắm",
        slotCount: 4,
        amenities: ["WiFi tốc độ cao", "Bồn tắm view thành phố", "Điều hòa", "Máy chiếu", "Minibar"],
    },
    {
        id: "coco",
        name: "BB's Coco",
        type: "vip",
        image: room6,
        pricePerSlot: 309000,
        rating: 4.8,
        reviewCount: 7,
        guests: 2,
        areaM2: 24,
        bed: "1 giường đôi King size",
        slotCount: 4,
        amenities: ["WiFi tốc độ cao", "Bồn tắm", "Điều hòa", "Vòi sen nóng lạnh", "Bàn trang điểm"],
    },
]
